"use strict";

module.exports = {
  'name': 'sqrt',
  'category': 'Arithmetic',
  'syntax': ['sqrt(x)'],
  'description': 'Compute the square root value. If x = y * y, then y is the square root of x.',
  'examples': ['sqrt(25)', '5 * 5', 'sqrt(-1)'],
  'seealso': ['square', 'sqrtm', 'multiply', 'nthRoot', 'nthRoots', 'pow']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/arithmetic/sqrt.js
// module id = 853
// module chunks = 0